import { Constants } from "@core/Utils/Constants";
import { WinType } from "@core/Logic/Bets";
import { effectsVolume, musicVolume } from "../Utils/Constants";
import { Client } from "@core/Client";

export class WinDisplay {

    private shown: boolean = false;
    private backGlow: Phaser.GameObjects.Sprite;
    private levelText: Phaser.GameObjects.Sprite;
    private winText: Phaser.GameObjects.Sprite;
    private winAmountText: Phaser.GameObjects.BitmapText;

    private particleW: number;
    private particleH: number;

    private alphaAnimation: Phaser.Tweens.Tween;
    private alphaHideAnimation: Phaser.Tweens.Tween;
    private zoomHideAnimation: Phaser.Tweens.Tween;
    private zoomAnimation: Phaser.Tweens.Tween;
    private zoomAnimationToScale: number = 1;
    private particleInterval: any;

    private callHideTimeout;
    private hideInABit;
    private playingJackpotWin: boolean = false;

    constructor(private scene: Phaser.Scene) {
        Client.game.events.on(Constants.EVENTS.PLAY_WIN, (num: number, whatWasWon: string = "") => { this.Play(num, whatWasWon) }, this);

        this.backGlow = new Phaser.GameObjects.Sprite(scene, 0, 0, Constants.SPRITESHEET_WINS, "Glow.png");
        this.backGlow.setOrigin(0.5);
        this.backGlow.setAlpha(0.75);
        scene.children.add(this.backGlow);
        scene.children.bringToTop(this.backGlow);

        this.winText = new Phaser.GameObjects.Sprite(scene, 0, 0, Constants.SPRITESHEET_WINS, "Win.png");
        this.winText.setOrigin(0.5, 0);
        scene.children.add(this.winText);
        scene.children.bringToTop(this.winText);

        this.levelText = new Phaser.GameObjects.Sprite(scene, 0, 0, Constants.SPRITESHEET_WINS, "Big.png");
        this.levelText.setOrigin(0.5, 1);
        scene.children.add(this.levelText);
        scene.children.bringToTop(this.levelText);

        this.winAmountText = new Phaser.GameObjects.BitmapText(scene, 0, 0, Constants.BITMAP_FONTS.MONTSERRAT, "", 110);
        this.winAmountText.setOrigin(0.5, 0);
        scene.children.add(this.winAmountText);
        scene.children.bringToTop(this.winAmountText);

        this.zoomAnimation = this.scene.tweens.add({
            targets: [this.winText, this.levelText, this.winAmountText],
            alpha: { from: 1, to: 1 },
            scale: { from: 0, to: this.zoomAnimationToScale },
            ease: 'Linear',
            duration: 250,
            repeat: 0,
            yoyo: false,
            paused: true
        });
        this.alphaAnimation = this.scene.tweens.add({
            targets: [this.backGlow],
            alpha: { from: 0, to: 0.75 },
            ease: 'Linear',
            duration: 1000,
            repeat: 0,
            yoyo: false,
            paused: true
        });

        this.zoomHideAnimation = this.scene.tweens.add({
            targets: [this.winText, this.levelText, this.winAmountText],
            alpha: { from: 1, to: 1 },
            scale: { from: this.zoomAnimationToScale, to: 0 },
            ease: 'Linear',
            duration: 250,
            repeat: 0,
            yoyo: false,
            paused: true
        });
        this.alphaHideAnimation = this.scene.tweens.add({
            targets: [this.backGlow],
            alpha: { from: 0.75, to: 0 },
            ease: 'Linear',
            duration: 500,
            repeat: 0,
            yoyo: false,
            paused: true
        });

        this.backGlow.visible = false;
        this.winText.visible = false;
        this.levelText.visible = false;
        this.winAmountText.visible = false;
    }

    OnResize(y: number, x: number, boardHeight: number, boardWidth: number, staticWidth: number, staticHeight: number, portraitMode: boolean): void {
        this.particleW = staticWidth;

        if (portraitMode)
            this.particleH = 0 - staticHeight;
        else
            this.particleH = staticHeight;

        this.backGlow.setDisplaySize(boardWidth, boardHeight);
        this.backGlow.scale = Math.min(this.backGlow.scaleX, this.backGlow.scaleY);

        this.winText.setDisplaySize(boardWidth, boardHeight / 4);
        this.winAmountText.scale = this.zoomAnimationToScale = this.winText.scale = Math.min(this.winText.scaleX, this.winText.scaleY);

        this.backGlow.x = x;
        this.backGlow.y = y;

        this.winText.x = x;
        this.winText.y = y;

        this.levelText.x = x;
        this.levelText.y = y;

        this.winAmountText.x = x;
        this.winAmountText.y = this.winText.y + this.winText.displayHeight;

        this.scene.children.bringToTop(this.backGlow);
        this.scene.children.bringToTop(this.winText);
        this.scene.children.bringToTop(this.levelText);
        this.scene.children.bringToTop(this.winAmountText);

        this.zoomAnimation.removeAllListeners();
        this.scene.tweens.remove(this.zoomAnimation);
        this.zoomAnimation = null;
        this.zoomAnimation = this.scene.tweens.add({
            targets: [this.winText, this.levelText, this.winAmountText],
            alpha: { from: 1, to: 1 },
            scale: { from: 0, to: this.zoomAnimationToScale },
            ease: 'Linear',
            duration: 250,
            repeat: 0,
            yoyo: false,
            paused: true
        });

        this.alphaAnimation.removeAllListeners();
        this.scene.tweens.remove(this.alphaAnimation);
        this.alphaAnimation = null;
        this.alphaAnimation = this.scene.tweens.add({
            targets: [this.backGlow],
            alpha: { from: 0, to: 0.75 },
            ease: 'Linear',
            duration: 1000,
            repeat: 0,
            yoyo: false,
            paused: true
        });

        this.zoomHideAnimation.removeAllListeners();
        this.scene.tweens.remove(this.zoomHideAnimation);
        this.zoomHideAnimation = null;
        this.zoomHideAnimation = this.scene.tweens.add({
            targets: [this.winText, this.levelText, this.winAmountText],
            alpha: { from: 1, to: 1 },
            scale: { from: this.zoomAnimationToScale, to: 0 },
            ease: 'Linear',
            duration: 250,
            repeat: 0,
            yoyo: false,
            paused: true
        });

        this.alphaHideAnimation.removeAllListeners();
        this.scene.tweens.remove(this.alphaHideAnimation);
        this.alphaHideAnimation = null;
        this.alphaHideAnimation = this.scene.tweens.add({
            targets: [this.backGlow],
            alpha: { from: 0.75, to: 0 },
            ease: 'Linear',
            duration: 500,
            repeat: 0,
            yoyo: false,
            paused: true
        });
    }

    Show(): void {
        this.shown = true;

        this.backGlow.visible = true;
        this.winText.visible = true;
        this.levelText.visible = true;

        if (this.zoomHideAnimation.isPlaying())
            this.zoomHideAnimation.pause();
        if (this.alphaHideAnimation.isPlaying())
            this.alphaHideAnimation.pause();

        this.zoomAnimation.play();
        this.alphaAnimation.play();

        if (!this.playingJackpotWin)
            this.callHideTimeout = setTimeout(function () { this.Hide() }.bind(this), 3000);
    }

    Hide(): void {
        this.shown = false;

        if (this.zoomAnimation.isPlaying())
            this.zoomAnimation.pause();
        if (this.alphaAnimation.isPlaying())
            this.zoomAnimation.pause();

        this.zoomHideAnimation.play();
        this.alphaHideAnimation.play();

        this.hideInABit = setTimeout(function () {
            this.backGlow.visible = false;
            this.winText.visible = false;
            this.levelText.visible = false;
            this.winAmountText.visible = false;
        }.bind(this), 1000);
    }

    Cancel(): void {
        if (this.zoomAnimation.isPlaying())
            this.zoomAnimation.pause();
        if (this.alphaAnimation.isPlaying())
            this.zoomAnimation.pause();

        if (this.zoomHideAnimation.isPlaying())
            this.zoomHideAnimation.pause();
        if (this.alphaHideAnimation.isPlaying())
            this.alphaHideAnimation.pause();

        this.backGlow.visible = false;
        this.winText.visible = false;
        this.levelText.visible = false;
        this.winAmountText.visible = false;

        clearTimeout(this.callHideTimeout);
        clearTimeout(this.hideInABit);
    }

    Play(num: number, whatWasWon: string = ""): void {
        if (this.playingJackpotWin)
            return;

        if (this.shown && num != WinType.JACKPOT)
            return;

        if (this.shown && num == WinType.JACKPOT)
            this.Cancel();

        let winSound;
        Client.game.events.emit("FADE_BACKGROUND_MUSIC", false);

        if (whatWasWon.length > 0) {
            this.winAmountText.text = whatWasWon;
            this.winAmountText.visible = true;
        }

        switch (num) {
            case WinType.NORMAL:
                winSound = Client.game.sound.get(Constants.SOUNDS.CHIPS_DROPS);
                winSound.once("complete", () => { Client.game.events.emit("FADE_BACKGROUND_MUSIC", true) });
                break;
            case WinType.BIG:
                this.levelText.setFrame("Big.png");
                winSound = Client.game.sound.get(Constants.SOUNDS.WIN_1);
                winSound.once("complete", () => { Client.game.events.emit("FADE_BACKGROUND_MUSIC", true) });
                this.Show();
                break;
            case WinType.MEGA:
                this.levelText.setFrame("Mega.png");
                winSound = Client.game.sound.get(Constants.SOUNDS.WIN_2);
                winSound.once("complete", () => { Client.game.events.emit("FADE_BACKGROUND_MUSIC", true) });
                this.Show();
                break;
            case WinType.EPIC:
                this.levelText.setFrame("Epic.png");
                winSound = Client.game.sound.get(Constants.SOUNDS.WIN_3);
                winSound.once("complete", () => { Client.game.events.emit("FADE_BACKGROUND_MUSIC", true) });
                this.Show();
                break;
            case WinType.JACKPOT:
                this.playingJackpotWin = true;
                this.levelText.setFrame("Jackpot.png");

                let particleRatio = this.particleW / 1024;

                let particle = this.scene.add.particles(Constants.SPRITESHEET_PARTICLES);
                let emitter1 = particle.createEmitter({
                    frame: 'red.png',
                    x: 100,
                    y: 100,
                    speed: { min: 80 * particleRatio, max: 150 * particleRatio },
                    scale: { min: 0.1 * particleRatio, max: 0.25 * particleRatio },
                    blendMode: 'NORMAL',
                    gravityY: 80 * particleRatio,
                    on: false,
                    maxParticles: 250,
                    lifespan: { min: 250 * particleRatio, max: 500 * particleRatio },
                });
                let emitter2 = particle.createEmitter({
                    frame: 'green.png',
                    x: 100,
                    y: 100,
                    speed: { min: 80 * particleRatio, max: 150 * particleRatio },
                    scale: { min: 0.1 * particleRatio, max: 0.25 * particleRatio },
                    blendMode: 'NORMAL',
                    gravityY: 80 * particleRatio,
                    on: false,
                    maxParticles: 250,
                    lifespan: { min: 250 * particleRatio, max: 500 * particleRatio },
                });
                let emitter3 = particle.createEmitter({
                    frame: 'blue.png',
                    x: 100,
                    y: 100,
                    speed: { min: 80 * particleRatio, max: 150 * particleRatio },
                    scale: { min: 0.1 * particleRatio, max: 0.25 * particleRatio },
                    blendMode: 'NORMAL',
                    gravityY: 80 * particleRatio,
                    on: false,
                    maxParticles: 250,
                    lifespan: { min: 250 * particleRatio, max: 500 * particleRatio },
                });
                let emitter4 = particle.createEmitter({
                    frame: 'yellow.png',
                    x: 100,
                    y: 100,
                    speed: { min: 80 * particleRatio, max: 150 * particleRatio },
                    scale: { min: 0.1 * particleRatio, max: 0.25 * particleRatio },
                    blendMode: 'NORMAL',
                    gravityY: 80 * particleRatio,
                    on: false,
                    maxParticles: 250,
                    lifespan: { min: 250 * particleRatio, max: 500 * particleRatio },
                });

                this.particleInterval = setInterval(function () {
                    switch (Math.floor(Math.random() * 4)) {
                        case 0:
                            emitter1.explode(20 * (Math.random() + 0.5), Math.random() * this.particleW, Math.random() * this.particleH);
                            break;
                        case 1:
                            emitter2.explode(20 * (Math.random() + 0.5), Math.random() * this.particleW, Math.random() * this.particleH);
                            break;
                        case 2:
                            emitter3.explode(20 * (Math.random() + 0.5), Math.random() * this.particleW, Math.random() * this.particleH);
                            break;
                        case 3:
                            emitter4.explode(20 * (Math.random() + 0.5), Math.random() * this.particleW, Math.random() * this.particleH);
                            break;
                        default:
                            emitter1.explode(20 * (Math.random() + 0.5), Math.random() * this.particleW, Math.random() * this.particleH);
                            break;
                    }
                    switch (Math.floor(Math.random() * 4)) {
                        case 0:
                            emitter1.explode(20 * (Math.random() + 0.5), Math.random() * this.particleW, Math.random() * this.particleH);
                            break;
                        case 1:
                            emitter2.explode(20 * (Math.random() + 0.5), Math.random() * this.particleW, Math.random() * this.particleH);
                            break;
                        case 2:
                            emitter3.explode(20 * (Math.random() + 0.5), Math.random() * this.particleW, Math.random() * this.particleH);
                            break;
                        case 3:
                            emitter4.explode(20 * (Math.random() + 0.5), Math.random() * this.particleW, Math.random() * this.particleH);
                            break;
                        default:
                            emitter4.explode(20 * (Math.random() + 0.5), Math.random() * this.particleW, Math.random() * this.particleH);
                            break;
                    }
                }.bind(this), 650);

                Client.game.sound.add(Constants.SOUNDS.JACKPOT_WIN, { volume: 0.45 * musicVolume })
                winSound = Client.game.sound.get(Constants.SOUNDS.JACKPOT_WIN);
                winSound.once("complete", () => {
                    clearInterval(this.particleInterval);

                    emitter1.remove();
                    emitter2.remove();
                    emitter3.remove();
                    emitter4.remove();

                    emitter1 = null;
                    emitter2 = null;
                    emitter3 = null;
                    emitter4 = null;

                    particle.destroy();

                    this.Hide();
                    Client.game.events.emit("FADE_BACKGROUND_MUSIC", true);
                    this.playingJackpotWin = false;
                });

                this.winAmountText.setFont('jackpotSilver', 110);
                this.winAmountText.setTint(0xf7e8a2, 0xf1d55b, 0xebc314, 0xd3b012);

                this.Show();
                break;
        }

        winSound.play({ volume: 0.45 * effectsVolume });
    }

    public Update(time: number): void {
        if (!this.shown)
            return;
        this.backGlow.rotation += 0.5 * time / 1000.0;
    }
}